import { FC, PropsWithChildren } from 'react';
import Header from 'shared/components/header/container/header';

const Layout: FC<PropsWithChildren> = ({ children }) => {
	return (
		<div>
			<Header />
			<div className='main-content-wrapper'>{children}</div>
		</div>
	);
};

export default Layout;
